// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1KqfM","footer":"ModalUpdate_footer__PYCpj"};